export function timeEntryValue(entry){
  if(!entry?.billable)return 0;
  return Math.round((Number(entry.minutes)||0)*(Number(entry.hourly_rate)||0)/60*100)/100;
}

export function invoiceBalance(invoice,payments){
  const paid=payments.filter(payment=>payment.invoice_id===invoice.id).reduce((sum,payment)=>sum+Number(payment.amount||0),0);
  return Math.max(0,Math.round((Number(invoice.amount||0)-paid)*100)/100);
}

export function financeSummary(entries,invoices,payments){
  const minutes=entries.reduce((sum,entry)=>sum+Number(entry.minutes||0),0);
  const billable=entries.reduce((sum,entry)=>sum+timeEntryValue(entry),0);
  const invoiced=invoices.filter(invoice=>invoice.status!=='draft').reduce((sum,invoice)=>sum+Number(invoice.amount||0),0);
  const collected=payments.reduce((sum,payment)=>sum+Number(payment.amount||0),0);
  const outstanding=invoices.filter(invoice=>invoice.status!=='draft').reduce((sum,invoice)=>sum+invoiceBalance(invoice,payments),0);
  return {minutes,billable:Math.round(billable*100)/100,invoiced:Math.round(invoiced*100)/100,collected:Math.round(collected*100)/100,outstanding:Math.round(outstanding*100)/100};
}

export function receivablesAging(invoices,payments,today=new Date()){
  const buckets={notDue:0,days1to30:0,days31to60:0,daysOver60:0,noDueDate:0};
  const midnight=new Date(today.getFullYear(),today.getMonth(),today.getDate()).getTime();
  for(const invoice of invoices){
    if(invoice.status==='draft')continue;
    const balance=invoiceBalance(invoice,payments);if(balance<=0)continue;
    const due=invoice.due_at?new Date(`${invoice.due_at}T00:00:00`):null;
    if(!due||Number.isNaN(due.getTime()))buckets.noDueDate+=balance;
    else{
      const days=Math.floor((midnight-due.getTime())/86400000);
      const key=days<=0?'notDue':days<=30?'days1to30':days<=60?'days31to60':'daysOver60';
      buckets[key]+=balance;
    }
  }
  return Object.fromEntries(Object.entries(buckets).map(([key,value])=>[key,Math.round(value*100)/100]));
}

export function timeByUser(entries){
  const grouped=new Map();
  for(const entry of entries){
    const userId=entry.user_id||'unknown';const row=grouped.get(userId)||{userId,minutes:0,billable:0};
    row.minutes+=Number(entry.minutes||0);row.billable+=timeEntryValue(entry);grouped.set(userId,row);
  }
  return [...grouped.values()].sort((a,b)=>b.minutes-a.minutes).map(row=>({...row,billable:Math.round(row.billable*100)/100}));
}
